import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHBusinessSolutionBody from "./Components/BodyBusinessSolution";

class CHBusinessSolution extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHBusinessSolutionBody />
        <Footer />
      </>
    );
  }
}

export default CHBusinessSolution;
